import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import symbolInTable from "@/components/WalletPage/SymbolInTable/index.vue";
import rangeInTable from "@/components/WalletPage/RangeInTable/index.vue";
import ProfitOrLosesPercentInTable from "@/components/WalletPage/ProfitOrLosesPercentInTable/index.vue";
import ProfitOrLosesAmountInTable from "@/components/WalletPage/ProfitOrLosesAmountInTable/index.vue";
import updateInTable from "@/components/WalletPage/UpdateInTable/index.vue";
import detailsInTable from "@/components/TransactionsPage/DetailsInTable/index.vue";
import draggable from "vuedraggable";
import { noRowsTemplate } from "../noRowsTemplate";
import statusInTable from "@/components/TransactionsPage/StatusInTable/index.vue";
import PricesAndIsoInTable from "@/components/TransactionsPage/PricesAndIsoInTable/index.vue";
import verifyInTable from "@/components/TransactionsPage/VerifyInTable/index.vue";
import { TransactionService } from "@/services";
import dayjs from "@/utiles/dayjs";
import transactionsFilter from "@/components/TransactionsPage/TransactionsFilter/index";

export default {
  name: "withdrawal-table",
  components: {
    AgGridVue,
    symbolInTable,
    rangeInTable,
    ProfitOrLosesPercentInTable,
    ProfitOrLosesAmountInTable,
    updateInTable,
    draggable,
    detailsInTable,
    statusInTable,
    PricesAndIsoInTable,
    verifyInTable,
    transactionsFilter
  },
  mixins: [$exponent, $thousandMask],
  data() {
    return {
      page: 1,
      withdrawTableLoader: true,
      loading: false,
      tab: 0,
      isMenuOpen: false,
      dataTableShow: false,
      showMyPrices: false,
      arrowTopImage: require("../../../assets/image/up.svg"),
      arrowDownImage: require("../../../assets/image/down.svg"),
      dataTableItem: "",
      gridOptions: null,
      gridApi: null,
      localeText: null,
      columnApi: null,
      withdrawalTableHeader: null,
      defaultWithdrawalHeader: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      tableItemShow: [
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 },
        { name: this.$t("transactionsPage.withdrawalTable.all"), value: 100 }
      ],
      tableItemShowFirstIndex: 10,
      item: "10",
      rialWithdrawalHeader: null,
      cryptoWithdrawalHeader: null,
      requestQuery: {},
      statusQuery: {
        type: ""
      },
      statusList: []
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      immediate: true,
      handler(updatedQuery) {
        if (Object.entries(updatedQuery).length > 0) {
          this.getTradeDepositOrderData(updatedQuery, 1);
        }
      }
    }
    // getQueryParams: {
    //   deep: true,
    //   handler(newValue, oldValue) {
    //     if (Object.entries(newValue).length >= 1) {
    //       if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
    //         this.getTradeDepositOrderData(this.getQueryParams, this.page);
    //       }
    //     }
    //   }
    // }
  },
  computed: {
    ...mapGetters({
      transactionsDrawer: types.transactions.getters.GET_TRANSACTIONS_DRAWER,
      getTransactionOrderData:
        types.transactions.getters.GET_TRANSACTIONS_ORDER,
      getTransactionStatusList:
        types.transactions.getters.ACTION_TRANSACTIONS_STATUS_LIST,
      getTransactionQuery: types.transactions.getters.ACTION_TRANSACTIONS_QUERY
    }),
    getQueryParams() {
      if (Object.entries(this.$route.query).length > 1) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          if (
            (key === "status" || key === "currency") &&
            !Array.isArray(value)
          ) {
            this.$route.query[key] = [value];
          }
        });
      }
      return this.$route.query;
    },
    filterStatusList() {
      return this.statusList.filter(elem => {
        if (
          "status" in this.getQueryParams &&
          this.getQueryParams.status.includes(elem.value)
        ) {
          return elem;
        }
      });
    },
    showWithdrawData() {
      let data = [];
      this.withdrawTableLoader = false;
      if (this.tab === 0) {
        if (Object.entries(this.getTransactionOrderData).length > 0) {
          this.getTransactionOrderData.data.forEach(elem => {
            data.push({
              transaction_id: elem.reference_number,
              amount: {
                value: elem.currency_amount,
                iso: elem.currency_iso
              },
              date:
                this.formatTimes(elem.created_at) +
                " - " +
                this.formatDate(elem.created_at),
              // time: this.formatTimes(elem.created_at),
              status: { locale: elem.status.locale, style: elem.status.style },
              verify: {
                type: elem.status.value,
                reference_number: elem.reference_number,
                orderType: "withdrawal"
              },
              // description: elem.latest_description,
              operation: {
                transaction_type: "withdrawRial",
                drawer: true,
                reference_number: elem.reference_number
              }
            });
          });
          return data;
        }
      } else if (this.tab === 1) {
        if (Object.entries(this.getTransactionOrderData).length > 0) {
          this.getTransactionOrderData.data.forEach(elem => {
            data.push({
              currency: {
                logo: elem.currency_logo,
                iso: elem.currency_name
              },
              transaction_id: elem.reference_number,
              amount: {
                value: elem.currency_amount,
                iso: elem.currency_iso
              },
              date:
                this.formatTimes(elem.created_at) +
                " - " +
                this.formatDate(elem.created_at),
              // time: this.formatTimes(elem.created_at),
              status: {
                locale: elem.status.locale,
                style: elem.status.style
              },
              verify: {
                type: elem.status.value,
                reference_number: elem.reference_number,
                orderType: "withdrawal"
              },
              // description: elem.latest_description,
              operation: {
                transaction_type: "withdrawCrypto",
                drawer: true,
                reference_number: elem.reference_number
              }
            });
          });
          return data;
        }
      }
    },
    showPaginationCount() {
      if (Object.entries(this.getTransactionOrderData).length > 0) {
        return this.getTransactionOrderData.pagination;
      }
    }
  },
  beforeMount() {
    this.localeText = {
      to: this.$t("transactionsPage.withdrawalTable.to"),
      of: this.$t("transactionsPage.withdrawalTable.from")
    };
    this.gridOptions = {
      overlayNoRowsTemplate: noRowsTemplate.template
    };
    // this.withdrawalTableHeader =
    //   this.tab === 0 ? this.rialWithdrawalHeader : this.cryptoWithdrawalHeader;
    this.rialWithdrawalHeader = [
      {
        colId: 0,
        headerName: this.$t("transactionsPage.withdrawalTable.transactionId"),
        field: "transaction_id",
        flex: 1,
        minWidth: 150
      },
      {
        colId: 1,
        headerName: this.$t(
          "transactionsPage.withdrawalTable.withdrawalAmount"
        ),
        field: "amount",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "PricesAndIsoInTable",
        flex: 1,
        minWidth: 150
      },
      {
        colId: 2,
        headerName: this.$t("transactionsPage.withdrawalTable.date"),
        field: "date",
        // sortable: true,
        unSortIcon: true,
        flex: 1,
        minWidth: 150,
        cellStyle: { direction: "rtl", width: "fit-content" }
      },
      // {
      //   colId: 3,
      //   headerName: this.$t("transactionsPage.withdrawalTable.time"),
      //   field: "time",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   minWidth: 150
      // },
      {
        colId: 4,
        headerName: this.$t("transactionsPage.withdrawalTable.status"),
        field: "status",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "statusInTable",
        flex: 1,
        minWidth: 150
      },
      // {
      //   colId: 5,
      //   headerName: "توضیحات",
      //   field: "description",
      //   cellRendererFramework: "DescriptionInTable",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   minWidth: 500
      // },
      {
        colId: 5,
        headerName: "",
        field: "verify",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "verifyInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      },
      {
        colId: 6,
        headerName: this.$t("transactionsPage.withdrawalTable.action"),
        field: "operation",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "detailsInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      }
    ];
    this.cryptoWithdrawalHeader = [
      {
        colId: 0,
        headerName: this.$t("transactionsPage.withdrawalTable.crypto"),
        field: "currency",
        // sortable: true,
        unSortIcon: true,
        flex: 1,
        minWidth: 150,
        cellRendererFramework: "symbolInTable"
      },
      {
        colId: 1,
        headerName: this.$t("transactionsPage.withdrawalTable.amount"),
        field: "amount",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "PricesAndIsoInTable",
        flex: 1,
        minWidth: 150
      },
      {
        colId: 2,
        headerName: this.$t("transactionsPage.withdrawalTable.transactionId"),
        field: "transaction_id",
        flex: 1,
        minWidth: 150
      },
      {
        colId: 3,
        headerName: this.$t("transactionsPage.withdrawalTable.date"),
        field: "date",
        // sortable: true,
        unSortIcon: true,
        flex: 1,
        minWidth: 150,
        cellStyle: { direction: "rtl", width: "fit-content" }
      },
      // {
      //   colId: 4,
      //   headerName: this.$t("transactionsPage.withdrawalTable.time"),
      //   field: "time",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   minWidth: 150
      // },
      {
        colId: 5,
        headerName: this.$t("transactionsPage.withdrawalTable.status"),
        field: "status",
        // sortable: true,
        unSortIcon: true,
        cellRendererFramework: "statusInTable",
        flex: 1,
        minWidth: 150
      },
      // {
      //   colId: 6,
      //   headerName: "توضیحات",
      //   field: "description",
      //   cellRendererFramework: "DescriptionInTable",
      //   // sortable: true,
      //   unSortIcon: true,
      //   flex: 1,
      //   minWidth: 500
      // },
      {
        colId: 6,
        headerName: "",
        field: "verify",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "verifyInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      },
      {
        colId: 7,
        headerName: this.$t("transactionsPage.withdrawalTable.action"),
        field: "operation",
        pinned: this.$vuetify.breakpoint.smAndDown
          ? ""
          : this.$vuetify.rtl
          ? "left"
          : "right",
        width: 120,
        cellRendererFramework: "detailsInTable",
        headerClass: "feature-cell header-table-ag-grid-cell"
      }
    ];
    this.defaultWithdrawalHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
    // this.paginationNumberFormatter = params => {
    //   return "[" + params.value.toLocaleString() + "]";
    // };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.initRouteQuery();
    // this.getTradeDepositOrderData(this.getQueryParams, this.page);
    this.getFilterStatusList();
    // this.setTransactionsCategory(this.$route.query.category);
  },
  methods: {
    ...mapActions({
      transactionsDrawerAction:
        types.transactions.actions.ACTION_TRANSACTIONS_DRAWER,
      // setTransactionsCategory:
      //   types.transactions.actions.ACTION_TRANSACTIONS_CATEGORY,
      transactionOrderData:
        types.transactions.actions.ACTION_TRANSACTIONS_ORDER,
      transactionStatusListAction:
        types.transactions.actions.ACTION_TRANSACTIONS_STATUS_LIST,
      setFiltersStatus: types.transactions.actions.ACTION_TRANSACTIONS_STATUS
    }),
    getFilterStatusList() {
      if (this.getQueryParams.category === "cryptoCurrency") {
        this.statusQuery.type = "withdraw_crypto";
      } else if (this.getQueryParams.category === "IRR") {
        this.statusQuery.type = "withdraw_rial";
      }
      TransactionService.getFiltersStatus(this.statusQuery).then(response => {
        this.setFiltersStatus(response.data.data);
        this.statusList = response.data.data;
      });
    },
    initRouteQuery() {
      if (this.$route.query.category === "cryptoCurrency") {
        this.tab = 1;
        if (Object.entries(this.getQueryParams).length <= 1) {
          this.$router.push(
            {
              query: {
                category: this.$t("operationsPage.routeQueryTypes[1].query")
              }
            },
            () => {}
          );
        } else {
          this.$router.push(
            {
              query: { ...this.getQueryParams }
            },
            () => {}
          );
        }
      } else {
        this.tab = 0;
        if (Object.entries(this.getQueryParams).length <= 1) {
          this.$router.push(
            {
              query: {
                category: this.$t("operationsPage.routeQueryTypes[0].query")
              }
            },
            () => {}
          );
        } else {
          this.$router.push(
            {
              query: { ...this.getQueryParams }
            },
            () => {}
          );
        }
      }
    },
    toggledDrawerState() {
      return this.transactionsDrawer;
    },
    filtersDrawerFunc() {
      this.transactionsDrawerAction(!this.toggledDrawerState());
    },
    onTabChange(category) {
      this.transactionStatusListAction([]);
      this.page = 1;

      if (this.getQueryParams.category !== category) {
        this.$router.push(
          {
            query: { category: category }
          },
          () => {}
        );
        // -------------COMMENTED getTradeDepositOrderData() FOR DEBUGGING-------------
        // this.getTradeDepositOrderData(this.getQueryParams);

        this.addQueryParameters(category);
        // this.setTransactionsCategory(category);
        this.getFilterStatusList();
      }
    },
    getTradeDepositOrderData(query, paginate) {
      if (this.getQueryParams.category === "IRR") {
        this.requestQuery = {
          order_type: "withdraw",
          currency_type: "rial",
          page: paginate || this.page,
          ...query
        };
      } else if (this.getQueryParams.category === "cryptoCurrency") {
        this.requestQuery = {
          order_type: "withdraw",
          currency_type: "crypto",
          page: paginate || this.page,
          ...query
        };
      }
      delete this.requestQuery.category;
      TransactionService.getTradeOrders(this.requestQuery)
        .then(response => {
          this.transactionOrderData(response.data);
        })
        .finally(() => {
          if (this.loading) {
            this.loading = false;
          }
        });
    },
    addQueryParameters(elem) {
      if (Object.entries(this.$route.query).length <= 1) {
        this.$router.push(
          {
            query: { category: elem }
          },
          () => {}
        );
      }
    },
    formatDate(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    },
    getWithdrawPerPage(page) {
      this.loading = true;
      this.getTradeDepositOrderData(this.getQueryParams, page);
    },
    remove(statusItem) {
      let queryObj = { ...this.getQueryParams };
      queryObj.status = queryObj.status.filter(
        elem => elem !== statusItem.value
      );
      if (
        Object.entries(queryObj).length === 2 &&
        queryObj.status.length === 0
      ) {
        queryObj = { category: this.getQueryParams.category };
        this.getTradeDepositOrderData(queryObj);
      }
      this.$router.replace({ query: { ...queryObj } }, () => {});
    },
    resetFilters() {
      this.$router.replace(
        { query: { category: this.getQueryParams.category } },
        () => {}
      );
      // this.getTradeDepositOrderData(this.getQueryParams, this.page);
    }
  }
};
